import { TrackingService } from '../support/tracking/TrackingService';

type IFrom = 'dashboard' | 'marketing' | 'mission detail';

const CAMPAIGN_MAP: {[key in IFrom]: string} = {
    'dashboard': 'id-011125',
    'marketing': 'imp-011125',
    'mission detail': 'mdr-011125'
};

export class SkywatchService {

    static inject = () => [TrackingService];
    constructor(private tracker: TrackingService) {};

    getQuote = ({ trackingFrom }: { trackingFrom: IFrom }) => {

        const campaign = CAMPAIGN_MAP[trackingFrom];

        const baseUrl = 'https://autopylot.portal.skywatch.ai/insurance/monthly';
        const url = `${baseUrl}?utm_source=autopylot&utm_medium=referral&utm_campaign=${campaign}&utm_content=free-quote`;

        window.open(url, '_blank');

        this.tracker.track('Insurance Quote Opened', () => ({
            from: trackingFrom,
            vendor: 'Skywatch',
            url
        }));

    };
}
